import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/stores";

import VueImg from "v-img";
import BootstrapVue from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import VuePageTransition from "vue-page-transition";
import VueViewer from "v-viewer";
import { ModalPlugin } from "bootstrap-vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import { validator } from "@/mixins/validator";
import { addPrefix } from "@/mixins/prefix";
import axios from "@/mixins/axios";
import VueAxios from "vue-axios";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/style.css";
import "boxicons/css/boxicons.min.css";
import "sweetalert2/src/sweetalert2.scss";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "aos/dist/aos.css";
import "viewerjs/dist/viewer.css";

Vue.use(VueImg);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(VuePageTransition);
Vue.use(VueViewer);
Vue.use(ModalPlugin);
Vue.use(CKEditor);
Vue.use(VueAxios, axios);
Vue.prototype.$validator = validator;
Vue.prototype.$addPrefix = addPrefix;

Vue.config.productionTip = false;

new Vue({
	store,
	router,
	render: (h) => h(App),
}).$mount("#app");
